import { render, staticRenderFns } from "./SetMemberLimitUpgrade.vue?vue&type=template&id=3de5987a&scoped=true"
import script from "./SetMemberLimitUpgrade.vue?vue&type=script&lang=js"
export * from "./SetMemberLimitUpgrade.vue?vue&type=script&lang=js"
import style0 from "./SetMemberLimitUpgrade.vue?vue&type=style&index=0&id=3de5987a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5987a",
  null
  
)

export default component.exports